
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 確認、確定系のボタン（ホバー時にのみ背景表示）
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonStrongHover extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
